ermi<template lang="pug">
div
    .p-a-sm.white.lt.box-shadow
            .m-t-sm.pull-right(v-show="!onLoading('fetch-role')")
                button.md-btn.md-raised.m-r-sm.m-b-sm.p-r-md.p-l-md.white(
                    @click="cancel",
                    :disabled="loading"
                ) Cancel

                button.md-btn.md-raised.m-b-sm.p-r-md.p-l-md.green(
                    @click="submit",
                    :disabled="loading",
                    v-if="!isAdminRole && canUpdate"
                )
                    v-loading(loader="save-role") Save

            nav(aria-label="breadcrumb")
                ol.breadcrumb.white.m-b-0.p-b-0
                    li.breadcrumb-item
                        router-link(to="/") Roles
                    li.breadcrumb-item.active(v-show="!onLoading('fetch-role')") {{ role.display_name }}
    
    .padding(v-if="isAdminRole")
        .alert.info Admin role is a role who can do anything. Therefore no permission is editable.
    
    .padding(v-show="!onLoading('fetch-role') && !isAdminRole")
        .row
            .col-md-8
                .box
                    .box-header
                        h3 {{ role.display_name }} - Permissions
                    .box-divider.m-a-0
                    .box-body
                        .box(v-for="group in permissionGroups", :key="`group_${group.id}`")
                            .box-header.dker
                                h3 {{ group.display_name }}
                            .box-divider.m-a-0
                            form
                                fieldset(:disabled="loading || !canUpdate")
                                    .table-responsive
                                        table.table.table-hover
                                            thead
                                                tr
                                                    th.w-lg Module
                                                    th.w-xs.text-center View
                                                    th.w-xs.text-center Create / Update
                                                    th.w-xs.text-center Delete
                                            tbody
                                                tr(v-for="(permissions, module) in groupPermByModules(group.permissions)")
                                                    td {{ module }}
                                                    td.text-center
                                                        div(v-if="findPermByType(permissions, type.view) != undefined")
                                                            label.md-check.m-l-sm
                                                                input(
                                                                    :checked="roleHasPermission(findPermByType(permissions, type.view).id)",
                                                                    type="checkbox",
                                                                    :value="findPermByType(permissions, type.view).id",
                                                                    class="has-value",
                                                                    @change="addPermission"
                                                                )
                                                                i.indigo
                                                        i.material-icons.text-muted(v-else) remove

                                                    td.text-center
                                                        div(v-if="findPermByType(permissions, type.save) != undefined")
                                                            label.md-check.m-l-sm
                                                                input(
                                                                    :checked="roleHasPermission(findPermByType(permissions, type.save).id)",
                                                                    type="checkbox",
                                                                    :value="findPermByType(permissions, type.save).id",
                                                                    class="has-value",
                                                                    @change="addPermission"
                                                                )
                                                                i.indigo
                                                        i.material-icons.text-muted(v-else) remove
                                                    
                                                    td.text-center
                                                        div(v-if="findPermByType(permissions, type.delete) != undefined")
                                                            label.md-check.m-l-sm
                                                                input(
                                                                    :checked="roleHasPermission(findPermByType(permissions, type.delete).id)",
                                                                    type="checkbox",
                                                                    :value="findPermByType(permissions, type.delete).id",
                                                                    class="has-value",
                                                                    @change="addPermission"
                                                                )
                                                                i.indigo
                                                        i.material-icons.text-muted(v-else) remove
</template>

<script>
import rolePermission from '@js/store/modules/role-permission';
import { mapActions, mapGetters } from 'vuex';
import { Event } from '@js/event-bus';

export default {
    computed: {
        ...mapGetters('rolePermission', [
            'permissionGroups',
            'role',
            'roleHasPermission',
        ]),

        type() {
            return {
                view: 1,
                save: 2,
                delete: 3,
            };
        },

        isAdminRole() {
            return this.$route.params.id == 'inventory_admin';
        },

        loading() {
            return this.onLoading('fetch-role') || this.onLoading('save-role');
        },

        canUpdate() {
            return this.can(this.permission.SAVE_ROLES);
        },
    },

    watch: {
        '$route.params.id': function(name) {
            if (!_.isNil(name)) {
                this.startLoading('fetch-role');
                this.getRole(name).then(() => this.endLoading('fetch-role'));
            }
        },
    },

    beforeCreate() {
        if (!this.$store.hasModule('rolePermission')) {
            this.$store.registerModule('rolePermission', rolePermission);
        }
    },

    async created() {
        this.startLoading('fetch-role');

        await this.getPermissionGroups();
        await this.getRole(this.$route.params.id);

        this.endLoading('fetch-role');
    },

    methods: {
        ...mapActions('rolePermission', [
            'getPermissionGroups',
            'getRole',
            'togglePermission',
            'savePermission',
        ]),

        groupPermByModules(permissions) {
            return _.groupBy(permissions, 'module.name');
        },

        findPermByType(permissions, type) {
            return permissions.find(p => p.type == type);
        },

        async submit() {
            this.startLoading('save-role');

            try {
                await this.savePermission();
                this.swal({ text: 'Role permission has successfully saved' });
                this.endLoading('save-role');
                Event.$emit('permission-saved');
            } catch (e) {
                this.endLoading('save-role');
                this.swalError({ text: e });
            }
        },
        cancel() {
            this.$router.push('/');
        },
        addPermission(e) {
            this.togglePermission(e.target.value);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/role_permissions/role-permissions.vue